import React, { useState } from "react";
import "../styles/armsform.css";
import logo from "../assets/images/logo.png";
import { useNavigate } from 'react-router-dom';

const SearchForm = () => {
    const [selectedOption, setSelectedOption] = useState("birthcert");
    const [cnic, setCnic] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [error, setError] = useState("");
    const [records, setRecords] = useState([]);
    const navigate = useNavigate();

    // Handle the search button click
    const handleSearch = async () => {
        // Validate input based on the selected option
        if (selectedOption !== "fir" && !cnic) {
            setError("Please enter CNIC");
            return;
        }
        if (selectedOption === "fir" && !phoneNo) {
            setError("Please enter Phone Number");
            return;
        }

        // Perform the search
        try {
            const response = await fetch("https://chaman.gob.pk/eac_backend/search.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    action: "get_records_by_cnic",
                    cnic: selectedOption !== "fir" ? cnic : null, // Send CNIC if not FIR
                    phone_no: selectedOption === "fir" ? phoneNo : null, // Send phone number if FIR
                    table: selectedOption.replace(" ", "").toLowerCase(),
                }),
            });

            const data = await response.json();

            if (data.status === "success" && data.data) {
                setRecords(data.data);
                setError("");
            } else {
                setError("No records found");
                setRecords([]);
            }
        } catch (err) {
            setError("Error fetching data");
            setRecords([]);
        }
    };

    // Handle the change in selected record type
    const handleOptionChange = (e) => {
        const newOption = e.target.value;
        setSelectedOption(newOption);
        setRecords([]); // Clear previously displayed records
        setError(""); // Clear any error messages
        setCnic(""); // Reset CNIC field
        setPhoneNo(""); // Reset Phone Number field
    };

    return (
        <div className="search-wrapper">
            <img src={logo} alt="E-AC Logo" className="logoS" />
                <h4 id="sh">Seach Application</h4>
            <div className="search-main">
                {/* <img src={logo} alt="E-AC Logo" className="logoS" /> */}
                {/* <div className="search-main"> */}
                {/* <h5 id="L">E-Administration Chaman</h5> */}
                <select
                    id="recordType"
                    value={selectedOption}
                    onChange={handleOptionChange}
                >
                    <option value="birthcert">Birth Certificate</option>
                    <option value="deathcert">Death Certificate</option>
                    <option value="marriagecert">Marriage Certificate</option>
                    <option value="localcert">Local Certificate</option>
                    <option value="localdom">Local Domicile</option>
                    <option value="passport">Passport Application</option>
                    <option value="arms">Arms License</option>
                    <option value="fir">FIR</option>
                    <option value="complaints">Complaints</option>
                </select>

                {/* Show CNIC input field for all types except FIR */}
                {selectedOption !== "fir" ? (
                    <input
                        id="s1"
                        type="text"
                        value={cnic}
                        onChange={(e) => setCnic(e.target.value)}
                        placeholder="Enter CNIC"
                    />
                ) : (
                    // Show Phone Number input field for FIR
                    <input
                        id="s2"
                        type="text"
                        value={phoneNo}
                        onChange={(e) => setPhoneNo(e.target.value)}
                        placeholder="Enter Phone Number"
                    />
                )}

                <button id="sb" onClick={handleSearch}>
                    <i className="fas fa-search"></i></button>

                {error && <p>{error}</p>}

                <div className="main">
                    {/* Display records if available */}
                    {records.length > 0 ? (
                        <div className="records-container">
                            {/* <h4 id="appselect">{selectedOption} Records</h4> */}
                            {records.map((record, i) => (
                                <div key={i} className="record-item">
                                    {selectedOption === "complaints" ? (
                                        <>
                                            <p>Name: {record.name}</p>
                                            <p>CNIC: {record.cnic}</p>
                                            <p>Complaint: {record.complaint}</p>
                                            <p>Priority: {record.priority}</p>
                                            <p>Feedback: {record.feedback}</p>
                                            <p>Status: {record.status}</p>
                                        </>
                                    ) : selectedOption === "fir" ? (
                                        <>
                                            <p id="sp">FIR ID: {record.token_id}</p>
                                            <p>Levies Station: {record.thana}</p>
                                            <p>Phone Number: {record.phone_no}</p>
                                            <p>Date of Report: {record.r_date}</p>
                                            <p>Status: {record.status_f}</p>
                                        </>
                                    ) : (
                                        <>
                                            <p id="sp">Token ID: {record.token_id}</p>
                                            <p>Name: {record.name}</p>
                                            <p>Father Name: {record.father_name}</p>
                                            <p>CNIC: {record.cnic}</p>
                                            <p>Date: {record.date}</p>
                                            <p>Status: {record.status}</p>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p id="rec">No records found</p>
                    )}
                </div>
            </div>
            
            <span id="searchapplication" onClick={() => navigate('*')} className="search-link"
          style={popupStyle}
          >
            Go to Login Page
          </span>
        </div>
        // </div>
    );
};

const popupStyle = {
    position: 'fixed',
    top: '10px',
    left: '0px',
    padding: '10px 15px',
    backgroundColor: 'rgba(59, 130, 246, 1)', // Initial background color
    color: 'white',
    borderTopRightRadius: '50px',
    borderBottomRightRadius: '50px',
    zIndex: 1000,
    cursor: 'pointer', // Makes the mouse pointer turn into a hand when hovering
    transition: 'background-color 0.3s ease', // Smooth transition for the color change
  };
  
  // Adding a hover effect that slightly darkens the color
  const hoverStyle = {
    ...popupStyle,
    backgroundColor: 'rgba(59, 130, 246, 2)', // Darker shade of the background color on hover
  };

export default SearchForm;
